<template>
  <div class="not-available">
    <div class="not-available__content">
      <p class="not-available__title">
        Not Available
      </p>
      <p class="not-available__description">
        Please try to describe it in more detail, for example: “I am looking for a pair of purple high-heeled shoes.”
      </p>
    </div>
    <img
      class="not-available__logo"
      src="https://cdn-image.bestdealer.com/app-bestdealer/1688/ai-search/no-available.png"
      alt="search unavailable"
    >
  </div>
</template>

<script setup>

</script>

<style lang="less" scoped>
.not-available {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  padding: 13px 16px;
  border-radius: 8px;
  background-color: #F8F8F8;

  @media (min-width: 1024px) {
    padding: 0 24px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__title {
    font-family: mon-600;
    font-size: 13px;
    color: #232323;

    @media (min-width: 1024px) {
      font-size: 16px;
    }
  }

  &__description {
    font-family: mon-500;
    font-size: 12px;
    color: #5C5C5C;
  }

  &__logo {
    width: 80px;
    height: 80px;

    @media (min-width: 1024px) {
      width: 124px;
      height: 124px;
    }
  }
}
</style>
